module.exports = __webpack_public_path__ + "static/media/car-wash.8937beb8.svg";